import {apiFetch} from './apiBase';

export const ACCOUNT_STATES = Object.freeze({
  NEW: 'new',
  LEGAL_UPDATE_REQUIRED: 'legal_update_required',
  READY: 'ready',
  DISABLED: 'disabled',
});

async function requireSuccessfulResponse(response, fallbackCode) {
  const data = await response?.json?.().catch(() => ({}));
  if (!response?.ok || !data?.ok) {
    const error = new Error(fallbackCode);
    error.code = data?.error || fallbackCode;
    error.status = response?.status;
    throw error;
  }
  return data;
}

export async function fetchAccountState() {
  const response = await apiFetch('/api/legal/account-state', {method: 'POST'});
  const data = await requireSuccessfulResponse(response, 'account_state_failed');
  if (!Object.values(ACCOUNT_STATES).includes(data.accountState)) {
    const error = new Error('account_state_invalid');
    error.code = 'account_state_invalid';
    throw error;
  }
  return data;
}

export async function completeAccount({
  legalAccepted,
  marketingConsent,
  source,
  invitationRef = '',
  attributionRef = '',
} = {}) {
  const response = await apiFetch('/api/legal/account-completion', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({
      legalAccepted: legalAccepted === true,
      ...(typeof marketingConsent === 'boolean' ? {marketingConsent} : {}),
      source,
      ...(invitationRef ? {invitationRef} : {}),
      ...(attributionRef ? {attributionRef} : {}),
    }),
  });
  return requireSuccessfulResponse(response, 'account_completion_failed');
}
